import { useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import {
  CalendarDays,
  ClipboardList,
  LayoutDashboard,
  UserRound,
  Wrench,
  Menu,
  X,
  LogOut,
} from "lucide-react";
import { useAuth } from "../lib/auth";

const items = [
  ["/technician", LayoutDashboard, "Overview", true],
  ["/technician/jobs", ClipboardList, "My Jobs"],
  ["/technician/schedule", CalendarDays, "Schedule"],
  ["/technician/profile", UserRound, "Profile"],
];

export default function TechnicianLayout() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { user, logout } = useAuth();
  return (
    <div className="technician-shell">
      <aside
        className={open ? "technician-sidebar open" : "technician-sidebar"}
      >
        <div className="technician-brand">
          <div className="tech-mark">
            <Wrench size={18} />
          </div>
          <div>
            <b>KIZAK</b>
            <small>Technician</small>
          </div>
        </div>
        <nav>
          {items.map(([to, Icon, label, exact]) => (
            <Link
              key={to}
              to={to}
              onClick={() => setOpen(false)}
              className={
                (
                  exact
                    ? location.pathname === to
                    : location.pathname.startsWith(to)
                )
                  ? "active"
                  : ""
              }
            >
              <Icon size={18} />
              <span>{label}</span>
            </Link>
          ))}
        </nav>
        <div className="technician-user">
          <b>{user?.name || "Technician"}</b>
          <small>{user?.phone || "Service team"}</small>
          <button onClick={logout}>
            <LogOut size={15} /> Sign out
          </button>
        </div>
      </aside>
      <div className="technician-main">
        <header className="technician-header">
          <button className="mobile-menu" onClick={() => setOpen(!open)}>
            {open ? <X /> : <Menu />}
          </button>
          <div>
            <span>Field Service</span>
            <b>{pageTitle(location.pathname)}</b>
          </div>
          <Link to="/shop" className="tech-storefront">
            Storefront
          </Link>
        </header>
        <main>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
function pageTitle(path) {
  if (path.includes("/jobs/")) return "Job details";
  if (path.includes("/jobs")) return "My jobs";
  if (path.includes("/schedule")) return "Schedule";
  if (path.includes("/profile")) return "Profile";
  return "Today";
}
